























import { Component } from 'vue-property-decorator';
import { FunctionTypes } from '@/enums/functionTypes';
import AvaivaledVue from '@/components/avaivaled.vue';
import { UserTypes } from '@/enums/userTypes';
import { CollectionAgencyTypes } from '@/enums/collectionAgencyTypes';
import PaypalEditor from '@/components/bill/PaypalEditor.vue';
import UnivaPayEditor from '@/components/bill/UnivaPayEditor.vue';
import PayrouteEditor from '@/components/bill/PayrouteEditor.vue';

@Component({
  components: {
    PaypalEditor,
    UnivaPayEditor,
    PayrouteEditor,
  }
})
export default class extends AvaivaledVue {
  private loading: boolean = true;
  private paypalLoading: boolean = false;

  get isMini(): boolean {
    return (this as any).$mq === 'mini';
  }

  get isStudent(): boolean {
    return this.userRole === UserTypes.Student;
  }

  get collectionAgency(): CollectionAgencyTypes {
    if (!this.user || !this.user.collectionAgency) {
      return CollectionAgencyTypes.None;
    }
    return this.user.collectionAgency;
  }

  get isPaypal() {
    switch (this.collectionAgency) {
      case CollectionAgencyTypes.PayPalAndCramSchool:
      case CollectionAgencyTypes.PayPalAndOther:
        return true;
      default:
        return false;
    }
  }

  get isUnivaPay() {
    return this.collectionAgency === CollectionAgencyTypes.UnivaPay;
  }

  private async created() {
    this.loading = true;

    const ok = await this.pageBackCheck(FunctionTypes.Bill);
    if (!ok) {
      return;
    }
  }

  private async mounted() {
    while (!this.user) {
      await new Promise((resolve) => setTimeout(resolve, 100));
    }
    this.loading = false;
  }

  private deactivated() {
    this.$destroy();
  }
}
